import { render, staticRenderFns } from "./CommodityDetailInfo.vue?vue&type=template&id=59c907b4&scoped=true&"
import script from "./CommodityDetailInfo.vue?vue&type=script&lang=js&"
export * from "./CommodityDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommodityDetailInfo.vue?vue&type=style&index=0&id=59c907b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c907b4",
  null
  
)

export default component.exports